import { connect } from 'react-redux';
import {
  ALERT_ACCOUNT_UPDATED,
  ALERT_RECOVER_PASSWORD_SENT,
  ALERT_UPDATE_ACCOUNT_ERROR,
} from '../../actions';

import AccountAlerts from '../../components/account/alerts';

const mapStateToProps = (state) => {
  const { ui: { alerts } } = state;
  const user = state.users.byId[state.users.current];
  return {
    email: user.email,
    isAccountUpdatedAlertVisible: alerts[ALERT_ACCOUNT_UPDATED],
    isPasswordRecoverSent: alerts[ALERT_RECOVER_PASSWORD_SENT],
    errorAlert: alerts[ALERT_UPDATE_ACCOUNT_ERROR],
  };
};

export default connect(mapStateToProps)(AccountAlerts);



// WEBPACK FOOTER //
// ./src/desktop/containers/account/alerts.container.js